import { useRef, useEffect, useContext } from "react";
import Chart from "chart.js/auto";
import { range } from "lodash";
import { UserContext } from "../../context";

function Chart15() {
  const { parkId } = useContext(UserContext);
  const element = useRef();
  useEffect(() => {
    const chart = new Chart(element.current, {
      type: "line",
      data: {
        labels: range(5).map((index) => `${2021 + index}年`),
        datasets: [
          {
            data: parkId === 67 ? [221, 232, 248, 257, 262] : (parkId === 69 ? [5, 9, 13, 16, 20] : [0, 0, 0, 0, 0]),
            fill: true,
            borderColor: "#2a9d8f",
          },
        ],
      },
      options: {
        scales: {
          y: {
            min: 0,
            // max: 5,
            ticks: { stepSize: 1 },
          },
        },
        aspectRatio: 1.5,
        layout: {
          // padding: 16
        },
        plugins: {
          legend: false,
        },
      },
    });
    return () => chart.destroy();
  }, [parkId]);
  return <canvas ref={element} />;
}

export default Chart15;
